<component-modal [showClose]="isFromProfile()" [showFooter]="false">
  <!-- Back Button (only on reset step and not from profile) -->
  @if ((isResetStep() || isEmailStep()) && !isFromProfile()) {
    <button type="button" headerPrefix type="button" class="btn btn-icon btn-icon-secondary" (click)="onBackClick()">
      <custom-icon name="chevronLeft" size="16" viewBox="0 0 16 16" />
    </button>
  }

  <ng-container body>
    <div class="d-flex flex-column gap-4">
      <!-- Email Step -->
      @if (isEmailStep()) {
        <div class="d-flex w-100 flex-column gap-4">
          <div class="d-flex flex-column gap-2 text-center">
            <h4 class="fw-bold">Password recovery</h4>
            <p class="ext-center text-muted m-0">Enter the email you use for 0docs.ai</p>
          </div>

          <div class="d-flex flex-column gap-4">
            <component-input
              type="email"
              label="Email"
              [isFocused]="shouldFocusEmail()"
              [value]="email()"
              [disabled]="isFromProfile()"
              [errorMessage]="emailError()"
              (valueChange)="onEmailChange($event!)"
              (enter)="onEmailEnter()" />

            <component-button-with-loading
              [isLoading]="isLoading()"
              [disabled]="!email()"
              cssClass="btn btn-primary btn-lg w-100"
              (click)="onRequestReset()">
              Continue
            </component-button-with-loading>
          </div>
        </div>
      }

      <!-- Email Sent Step -->
      @if (isSentStep()) {
        <div class="d-flex w-100 flex-column gap-4 text-center">
          <div class="d-flex flex-column gap-2">
            <h4 class="fw-bold">Reset your password</h4>
            <p class="text-muted m-0">
              If an account exists, we'll send instructions for resetting you password. Didn't get them? Check the email address
              or ask to resend the instructions.
            </p>
          </div>

          <div class="d-flex flex-column gap-4">
            <component-button-with-loading
              cssClass="btn btn-primary btn-lg w-100"
              [isLoading]="isLoading()"
              (click)="onBackToLogin()">
              {{ isFromProfile() || isUserAuthenticated() ? "Back to 0Docs" : "Back to Log in" }}
            </component-button-with-loading>

            <!--    <a href="#" (click)="onResendInstructions()">Resend the instructions again</a> -->
          </div>
        </div>
      }

      <!-- Reset Password Step -->
      @if (isResetStep()) {
        <div class="d-flex w-100 flex-column gap-4">
          <div class="d-flex flex-column gap-2 text-center">
            <h4 class="fw-bold">Password recovery</h4>
            <p class="text-center text-muted m-0">Email: {{ email() }}</p>
          </div>

          <div class="d-flex flex-column gap-4">
            <component-input
              type="password"
              label="New password"
              [isFocused]="shouldFocusPassword()"
              [value]="password()"
              [errorMessage]="passwordError()"
              (valueChange)="onPasswordChange($event!)"
              (enter)="onPasswordEnter()" />

            <component-button-with-loading
              [isLoading]="isLoading()"
              [disabled]="!password()"
              cssClass="btn btn-primary btn-lg w-100"
              (click)="onResetPassword()">
              Continue
            </component-button-with-loading>
          </div>
        </div>
      }

      <!-- Success Step -->
      @if (isSuccessStep()) {
        <div class="d-flex w-100 flex-column gap-4">
          <div class="d-flex flex-column gap-2 text-center">
            <h4 class="fw-bold">Password changed</h4>
            <p class="text-muted m-0">Your password has been changed successfully.</p>
          </div>

          <div class="d-flex flex-column gap-4">
            <component-button-with-loading
              cssClass="btn btn-primary btn-lg w-100"
              [isLoading]="isLoading()"
              (click)="onBackToLogin()">
              Back to Log in
            </component-button-with-loading>
          </div>
        </div>
      }
    </div>
  </ng-container>
</component-modal>
